module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('NoTopNavFooter'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "login-background"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "splash hiddden",
    attrs: {
      "src": "",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    class: {
      'pull-up': _vm.samlappname !== undefined && _vm.samlappname !== null && (_vm.samlappname.toLowerCase().indexOf('secure.cargillag.com') > -1 || _vm.samlappname.toLowerCase().indexOf('secure.cargillag.ca') > -1)
    }
  }, [(_vm.stateToken.trim() != '' && _vm.stateToken.trim() !== undefined && _vm.stateToken.trim() !== null && _vm.brandCode !== '003') ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "5px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.connectingToText ? _vm.connectingToText : 'Connecting to') + "\n          "), _c('img', {
    staticStyle: {
      "max-width": "100px"
    },
    attrs: {
      "id": "saml-logo"
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.loginBrandTopText.trim() !== '') ? _c('div', {
    staticClass: "loginBrandTopText"
  }, [_vm._v(_vm._s(_vm.loginBrandTopText))]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "widget-div"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accessDenied),
      expression: "accessDenied"
    }],
    staticClass: "clogindiv",
    staticStyle: {
      "text-align": "center",
      "color": "rgb(217, 57, 52)",
      "padding": "10px 30px",
      "font-size": "14px"
    }
  }, [_vm._m(0)]), _vm._v(" "), (_vm.isEmployeeLoginRequired) ? _c('div', {
    staticClass: "clogindiv"
  }, [_c('button', {
    staticClass: "btn btn-primary adduser-btn",
    attrs: {
      "id": "cargillLogin"
    },
    on: {
      "click": function($event) {
        _vm.openCargillUserLogin()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.ssoLoginTxt ? _vm.ssoLoginTxt : 'Sign In as an Employee'))])]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border": "1px solid #ddd",
      "border-radius": "3px",
      "height": "45px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "float": "left",
      "height": "100%",
      "background": "rgb(217,57,52)",
      "color": "#fff",
      "padding": "7px 3px 10px 7px",
      "border-top-left-radius": "3px",
      "border-bottom-left-radius": "3px"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle",
    staticStyle: {
      "margin-right": "5px",
      "font-size": "16px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "color": "#000000",
      "float": "left",
      "padding": "7px 3px 10px 10px"
    }
  }, [_vm._v("Access denied")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d48af610", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d48af610"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Login.vue
// module id = 720
// module chunks = 1